import React from 'react'
import { Document } from '@react-pdf/renderer'

import type { TAlarmReportProps } from 'src/parser/shared/PDF/Provider'

import { alarmPages } from './Preview'

export type TMultiAlarmPreviewProps = {
  reports: TAlarmReportProps[]
}

const MultiAlarmPreview = ({
  reports,
}: TMultiAlarmPreviewProps): JSX.Element => (
  <Document>{reports.flatMap(report => alarmPages(report))}</Document>
)

export default MultiAlarmPreview
